<template xmlns:mailto="http://www.w3.org/1999/xhtml">
  <div
    class="alert alert-calendar col-md-8"
    style="font-size: 18px; text-align: center; width: 100%"
  >
    <span
      class="pull-right"
      style="margin-left: 15px; color: black; cursor: pointer; transition: 0.7s"
      onclick="this.parentElement.style.display='none';"
    >
      &times;
    </span>
    <h3 style="text-transform: none" class="center">
      Przed nami długi czerwcowy weekend! 🌞
    </h3>
    <br />
    Aby zapewnić Ci pełen komfort korzystania z naszych usług, przekazujemy
    kilka ważnych informacji dotyczących dostaw oraz godzin pracy Biura Obsługi
    Klienta w dniach 4–6 czerwca 2026:
    <br />
    <br />
    <strong>📦 Harmonogram dostaw:</strong> Dostawy realizujemy zgodnie ze
    standardowym grafikiem – wszystko przyjedzie tak, jak zwykle! ☺️
    <br />
    <br />
    <strong>📞 Godziny pracy Biura Obsługi Klienta:</strong>
    <br />
    ● 4 czerwca – nieczynne
    <br />
    ● 5 czerwca – czynne od 7:00 do 15:00
    <br />
    ● 6 czerwca – czynne od 7:00 do 13:00
    <br />
    <br />
    Dziękujemy za wyrozumiałość i życzymy spokojnego, słonecznego długiego
    weekendu! 🌻
  </div>
</template>

<script>
export default {
  name: 'NtfyMessage'
}
</script>
